//
//
//
//
//
//
//
//
//
//
//
//

import Searchbar from '~/components/Searchbar';
import CompanyList from '~/pages/Company/_components/CompanyList';

export default {
  name: 'Enterprise',
  components: {
    Searchbar,
    CompanyList,
  },
  data() {
    return {
      confirmType: 1,
      jobList: [],
      conditions: {},
      pagerInfo: { size: 12, current: 1, total: 0 },
    };
  },
  head() {
    return {
      title: 'STEP1NE - 嚴選企業合作夥伴 | 擴編熱招',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '發現STEP1NE的精選企業合作夥伴和熱門職位',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '探索STEP1NE嚴選的企業合作夥伴，發現擴編熱招的頂尖職位機會。我們致力於連接優秀人才與領先企業，共創職業成功故事。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '探索STEP1NE嚴選的企業合作夥伴，發現擴編熱招的頂尖職位機會。我們致力於連接優秀人才與領先企業，共創職業成功故事。',
        },
      ],
    };
  },
  methods: {
    sortChange(payload) {
      this.conditions = {
        ...this.conditions,
        ...payload,
        confirmType: this.confirmType,
      };
    },
    onSearch(resultData) {
      this.jobList = resultData.records;

      const { current, size, total } = resultData;
      this.pagerInfo = { ...this.pagerInfo, current, size, total };

      if (process.browser) {
        window.scroll({
          top: this.$refs.searchbarArea.clientHeight,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
  },
  mounted() {
    let query = {};
    for (const [key, value] of Object.entries(this.$route.query)) {
      if (value !== null || value !== '') {
        query[key] = JSON.parse(this.$route.query[key]);
      }
    }
    this.conditions = {
      ...query,
      ...this.pagerInfo,
      confirmType: this.confirmType,
    };
  },
};
